/** A usable error page even when CMS or root data could not be loaded. */
export function ErrorPageContent({
  isNotFound = false,
  isEnglish = false,
  homeUrl = '/',
}: {
  isNotFound?: boolean;
  isEnglish?: boolean;
  homeUrl?: string;
}) {
  return (
    <main className="mx-auto max-w-3xl px-6 py-16 text-center">
      <h1 className="text-2xl font-bold">
        {isNotFound
          ? isEnglish
            ? 'Page not found'
            : '找不到此頁面'
          : isEnglish
          ? 'This page is temporarily unavailable'
          : '此頁面暫時未能載入'}
      </h1>
      <p className="mt-4">
        {isEnglish
          ? 'Please return to the home page or try again later.'
          : '請返回主頁，或稍後再試。'}
      </p>
      <a href={homeUrl} className="mt-6 inline-block underline">
        {isEnglish ? 'Return to home page' : '返回主頁'}
      </a>
    </main>
  );
}
